import { useEffect, useState, type CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { TopNav } from './TopNav';
import { motion } from 'motion/react';
import { useTheme } from '@/src/modules/hooks/useTheme';
import { useI18nLanguageSync } from '@/src/modules/hooks/useI18nLanguageSync';
import { useAdminSettings } from '@/src/modules/store/admin-settings.context';

export function Layout() {
  const { settings } = useAdminSettings();
  const [isCollapsed, setIsCollapsed] = useState(settings.layout.sidebarCollapsed);
  // Apply theme + CSS variables based on the admin's appearance prefs.
  useTheme();
  // Mirror the language preference into i18next + <html lang="">.
  useI18nLanguageSync();

  useEffect(() => {
    setIsCollapsed(settings.layout.sidebarCollapsed);
  }, [settings.layout.sidebarCollapsed]);

  return (
    <div className="min-h-screen bg-surface">
      <Sidebar isCollapsed={isCollapsed} onCollapsedChange={setIsCollapsed} />
      <div
        className="min-h-screen flex flex-col md:ml-[var(--sidebar-w)] transition-[margin-left] duration-250 ease-out"
        style={{ '--sidebar-w': isCollapsed ? '4.5rem' : '18rem' } as CSSProperties}
      >
        <TopNav />
        <main className="flex-1 p-6 md:p-10 pb-24 md:pb-10 max-w-[1440px] mx-auto w-full">
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
          >
            <Outlet />
          </motion.div>
        </main>
      </div>

      {/* Vercel-style progress bar */}
      <div className="fixed top-0 left-0 w-full h-0.5 z-[100] overflow-hidden pointer-events-none">
        <motion.div
          className="h-full bg-gradient-to-r from-primary via-electric-violet to-tertiary-container w-full"
          animate={{ x: ['-100%', '100%'] }}
          transition={{ repeat: Infinity, duration: 3, ease: 'linear' }}
        />
      </div>
    </div>
  );
}
